
export const formatDate = (dateString: string) => {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleString("pt-BR");
};

export const formatStorageLimit = (bytes: number | null) => {
  if (!bytes) return "N/A";
  const mb = bytes / (1024 * 1024);
  if (mb >= 1024) {
    return `${(mb / 1024).toFixed(1)} GB`;
  }
  return `${Math.round(mb)} MB`;
};

export function formatPct(v?: number | null, digits = 2) {
  if (v == null || Number.isNaN(v)) return "—";
  return `${v.toFixed(digits)}%`;
}

// % a.d.  ->  % a.a.
export const annualFromDaily = (dailyPct: number) =>
  ((1 + dailyPct/100) ** 252 - 1) * 100;

// Formatar data mensal como mm/aaaa
export const formatMonthYear = (iso: string) =>
  new Date(iso).toLocaleDateString('pt-BR', {month:'2-digit', year:'numeric'});
